import { status, StatusType } from '../typeStatus'

export const GET_MARCAS = 'GET_MARCAS'
export const GET_MARCAS_SUCCESS = 'GET_MARCAS_SUCCESS'
export const GET_MARCAS_ERROR = 'GET_MARCAS_ERROR'

export interface Marcas {
  images: string[]
}

export const InitialState: CompanyHomeState = {
  statusMarcas: status.initial,
  marcas: null,
}

export interface CompanyHomeState {
  statusMarcas: StatusType
  marcas: Marcas | null
}

export interface GetMarcas {
  type: typeof GET_MARCAS
  payload: null
}
export interface GetMarcasSuccess {
  type: typeof GET_MARCAS_SUCCESS
  payload: Marcas
}
export interface GetMarcasError {
  type: typeof GET_MARCAS_ERROR
  payload: null
}

export type CompanyHomeActions = GetMarcas | GetMarcasSuccess | GetMarcasError
